import {HTTP} from '../../common/http';
import {
  CLEAR_SEARCH,
  FETCH_COUNTRIES,
  FETCH_LOCATIONS,
  POST_SEARCH,
  SET_COUNTRY,
  SET_CURRENCY,
  SET_DRIVER_AGE,
  SET_DROPOFF_DATE,
  SET_DROPOFF_DIFFERENT,
  SET_DROPOFF_LOCATION,
  SET_DROPOFF_TIME,
  SET_GUEST_TOKEN,
  SET_PASSENGERS,
  SET_PICKUP_DATE,
  SET_PICKUP_LOCATION,
  SET_PICKUP_TIME,
  SET_PROMO_CODE,
  SET_QUOTE_ID,
  SET_SEARCH_STATE,
  SET_TRANSMISSION,
  SET_AGENT_ID,
} from './mutation-types';

export function fetchCountries({ commit }) {
  return HTTP.get(`countries`)
    .then((response) => commit(FETCH_COUNTRIES, response.data.data));
};

export function setCountry({ commit }, country) {
  commit(SET_COUNTRY, country);
};

export function fetchLocations({ commit }, country = null) {
  let parameters = 'include=country';

  if (country) {
    parameters += `&country_id=${country}`;
  }

  return HTTP.get(`locations?${parameters}`)
    .then((response) => commit(FETCH_LOCATIONS, response.data.data));
};

export function setPromoCode({ commit }, code) {
  commit(SET_PROMO_CODE, code);
};

export function setDriverAge({ commit }, age) {
  commit(SET_DRIVER_AGE, age);
};

export function setPassengers({ commit }, passengers) {
  commit(SET_PASSENGERS, passengers);
};

export function setTransmission({ commit }, transmission) {
  commit(SET_TRANSMISSION, transmission);
};

export function setDropoffDifferent({ commit }, different) {
  commit(SET_DROPOFF_DIFFERENT, different);
};

export function setPickupDate({ commit }, date) {
  commit(SET_PICKUP_DATE, date);
};

export function setPickupTime({ commit }, time) {
  commit(SET_PICKUP_TIME, time);
};

export function setDropoffDate({ commit }, date) {
  commit(SET_DROPOFF_DATE, date);
};

export function setDropoffTime({ commit }, time) {
  commit(SET_DROPOFF_TIME, time);
};

export function setPickupLocation({ commit }, location) {
  commit(SET_PICKUP_LOCATION, location);
};

export function setDropoffLocation({ commit }, location) {
  commit(SET_DROPOFF_LOCATION, location);
};

export function setAgentId({ commit }, agentId) {
  commit(SET_AGENT_ID, agentId);
}

export function postFrameSearch({ dispatch, state, commit }) {
  return new Promise((resolve, reject) => {
    basePostSearch(state)
      .then(response => {
        commit(SET_CURRENCY, response.data.data.converted_currency || response.data.data.currency);
        commit(SET_QUOTE_ID, response.data.data.id);
        commit(SET_GUEST_TOKEN, response.data.data.guest_token);
        const details = {
          id: response.data.data.id,
          currency: response.data.data.converted_currency || response.data.data.currency,
          guestToken: response.data.data.guest_token,
        };
        resolve(details);
      }).catch(error => reject(error));
    });
}

export function postSearch({ dispatch, state, commit }) {

  return new Promise((resolve, reject) => {
    basePostSearch(state)
        .then(response => {
          commit(SET_CURRENCY, response.data.data.converted_currency || response.data.data.currency);
          commit(SET_QUOTE_ID, response.data.data.id);
          commit(SET_GUEST_TOKEN, response.data.data.guest_token);
          resolve(response.data.data.id);
        }).catch(error => reject(error));
  });
}
export function postPortalSearch({ dispatch, state, commit },{url}) {

  return new Promise((resolve, reject) => {
    basePostSearch(state,url)
        .then(response => {
          commit(SET_CURRENCY, response.data.data.converted_currency || response.data.data.currency);
          commit(SET_QUOTE_ID, response.data.data.id);
          commit(SET_GUEST_TOKEN, response.data.data.guest_token);
          resolve(response.data.data.id);
        }).catch(error => reject(error));
  });
}

function basePostSearch(state,url) {
  const data = new FormData();

  data.append('source_id', window.greenmotion.sourceId || 1);
  data.append('currency', state.search.currency || window.greenmotion.defaultCurrency || 'GBP');

  data.append('locale', window.greenmotion.locale);
  data.append('start_date', state.search.pickupDate);
  data.append('start_time', state.search.pickupTime);
  data.append('end_date', state.search.dropoffDate);
  data.append('end_time', state.search.dropoffTime);
  data.append('pickup_location_id', state.search.pickupLocation.id);
  data.append('dropoff_location_id', state.search.dropoffDifferent ? state.search.dropoffLocation.id : state.search.pickupLocation.id);
  data.append('promo_code', state.search.promoCode);
  data.append('age', state.search.driverAge);
  data.append('referral_parameters', JSON.stringify(window.greenmotion.referral_parameters));

  if (state.search.agentId) {
    data.append('agent_id', state.search.agentId);
  }

  return HTTP.post(url ? url : `quotes`, data);
};

export function clearSearch({commit}) {
  commit(CLEAR_SEARCH);
}

/*
export function fetchGuestToken({commit }){
  return new Promise((resolve,reject) => {
    localStorage.getItem('guestToken');
    resolve(localStorage.getItem('guestToken'))
  }).then((value) => {
    console.log(value);
    // commit(SET_GUEST_TOKEN,value);
  });
}*/



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/search/actions.js